module.exports = __webpack_public_path__ + "static/img/icon-sun.bc4dd49.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/bargain/icon-sun.png
// module id = YX+4
// module chunks = 1